import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, PaginatedPackageAutoCompleteList, Package } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompletePackage {
  search?: string;
  includeArchived?: boolean;
  types?: Package['type'][];
}

function useAutoCompletePackage({
  search,
  includeArchived = false,
  types,
}: IUseAutoCompletePackage): UseQueryResult<AxiosResponse<PaginatedPackageAutoCompleteList>> {
  const fetchAutoCompletePackage = (): Promise<AxiosResponse<PaginatedPackageAutoCompleteList>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }

    if (!includeArchived) {
      params.is_archived = 'false';
    }
    if (types?.length) {
      params.type = types.join(',');
    }

    return client.get(`packages/auto_complete/?${encodeUrlParams(params)}`);
  };

  return useQuery(['packages', 'auto-complete', search, includeArchived, types], fetchAutoCompletePackage);
}

export default useAutoCompletePackage;
